var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAtom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2162 1.78361C13.6567 3.22405 12.4889 6.72719 9.60804 9.6081C6.72719 12.489 3.22404 13.6567 1.78359 12.2162C0.343156 10.7758 1.51086 7.27267 4.39175 4.39176C7.2726 1.51087 10.7758 0.34316 12.2162 1.78361ZM1.78348 1.78369C0.343041 3.22413 1.51075 6.72725 4.39163 9.60816C7.27249 12.4891 10.7756 13.6568 12.2161 12.2163C13.6565 10.7759 12.4888 7.27273 9.60792 4.39184C6.72707 1.51096 3.22392 0.343242 1.78348 1.78369Z",
    stroke: "white",
    strokeWidth: 0.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45817 6.99996C8.45817 7.80537 7.80525 8.45829 6.99984 8.45829C6.19443 8.45829 5.5415 7.80537 5.5415 6.99996C5.5415 6.19455 6.19443 5.54163 6.99984 5.54163C7.80525 5.54163 8.45817 6.19455 8.45817 6.99996Z",
    stroke: "white",
    strokeWidth: 0.875
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtom);
export default __webpack_public_path__ + "static/media/icon-atom.7b690b0822c84447debd1a2fd4fff359.svg";
export { ForwardRef as ReactComponent };